import type { JSX } from 'react'
import flags from './flags'
import { TIocCode } from './types'

export type FlagProps = {
    code: TIocCode

    /**
     * Size of the flag. Defaults to 'small'.
     */
    size?: 'small' | 'large'

    /**
     * Text shown on hover. If omitted, the country code (in uppercase) is used.
     * Note that we are intentially uppercasing the IOC code rather than using the ISO 3166-1-alpha-3 code, which is already uppercase, because the IOC codes are generally more familiar.
     */
    title?: string

    'data-testid'?: string
}

const Flag = ({ code, title, size = 'small', ...rest }: FlagProps): JSX.Element => {
    const style = (() => {
        // For example, this can happen when adding a new profile entry, when the country is not yet known
        if (!flags[code]) {
            return
        }

        return {
            backgroundPosition: `${flags[code][size][0]}px ${flags[code][size][1]}px`,
        }
    })()

    return (
        <span
            aria-hidden
            title={title || code.toUpperCase()}
            style={style}
            {...rest}
            className={`DsFlag-root DsFlag-${size}`}
        />
    )
}

export default Flag
